import { t } from 'i18next';
import { parseRawBoolean } from '@data/api/helpers';
import Image from './Image';
import MultilangText from './MultilangText';
const extractPackageName = (name, title) => {
    if (name === title) {
        return t('standard-rate');
    }
    // If the room is a package, the title will be in the format "Room Name (Package Name)"
    return title.slice(name.length + 2, -1);
};
export default class Accommodation {
    constructor(data, options) {
        var _a, _b, _c, _d, _e, _f;
        Object.defineProperty(this, "accommodations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "adults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "allotmentBlockName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amenities", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // @TECHDEBT: beds is never assigned
        Object.defineProperty(this, "beds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bookableLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bookedId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "detailedRates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "featuredPackageAlt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "featuredPackageImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "featuredPackageImageLarge", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "images", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isPackage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isPrivate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxAdults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxGuests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxKids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nights", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notDerivedMaxDailyRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notDerivedMinDailyRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notDerivedRate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "numAvailable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "numBeds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "numRemaining", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "obpPriceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "obpPricingEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageAddons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageTerms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rateId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rateMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rateMin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "smartPolicyRootId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sourceSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unit_ids", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data) {
            return;
        }
        this.id = data.room_type_id.toString();
        this.packageId = (_a = data.package_id) === null || _a === void 0 ? void 0 : _a.toString();
        this.rateId = (_b = data.rate_id) === null || _b === void 0 ? void 0 : _b.toString();
        this.packageTerms = data.package_terms || '';
        this.name = data.room_type_name;
        this.title = data.room_type_title;
        this.shortTitle = data.room_type_short_title;
        this.packageName = extractPackageName(this.name, this.title);
        this.description = data.room_type_desc;
        this.adults = parseInt(data.adults_inBasePrice);
        this.kids = parseInt(data.children_inBasePrice);
        this.notDerivedRate = data.not_derived_price
            ? data.not_derived_price.rate_basic
            : 0;
        this.notDerivedMaxDailyRate = data.not_derived_price
            ? data.not_derived_price.rate_max
            : 0;
        this.notDerivedMinDailyRate = data.not_derived_price
            ? data.not_derived_price.rate_min
            : 0;
        this.allotmentBlockName = data.allotment_block_name || null;
        this.rate = data.rate_basic;
        this.rateMin = data.rate_min;
        this.rateMax = data.rate_max;
        this.isPrivate = parseRawBoolean(data.is_private);
        this.packageDescription = data.package_desc || '';
        this.isPackage = parseRawBoolean(data.is_package);
        this.featuredPackageAlt = data.package_src_alt || '';
        this.featuredPackageImage = data.package_src || '';
        this.featuredPackageImageLarge = data.package_src_big || '';
        this.bookableLimit = parseInt(data.bookable_limit);
        this.packageAddons = data.package_addons
            ? data.package_addons.map((rawPackageAddon) => ({
                description: new MultilangText(rawPackageAddon.addon_description),
                id: rawPackageAddon.addon_id,
                name: new MultilangText(rawPackageAddon.addon_name),
            }))
            : [];
        this.obpPricingEnabled =
            Object.keys(((_c = data.guests) === null || _c === void 0 ? void 0 : _c.kid) || {}).length > 0 ||
                Object.keys(((_d = data.guests) === null || _d === void 0 ? void 0 : _d.adult) || {}).length > 0;
        this.obpPriceSettings =
            data.guests && this.obpPricingEnabled
                ? {
                    adult: !Array.isArray(data.guests.adult) ? data.guests.adult : {},
                    kid: !Array.isArray(data.guests.kid) ? data.guests.kid : {},
                }
                : null;
        this.sourceSettings = {
            bookableLimit: parseInt(data.bookable_limit),
            canSelectSpecificRoom: !!data.accommodations && Object.keys(data.accommodations).length > 0,
            capacity: parseInt(data.max_guests),
            maxRooms: data.max_rooms,
            roomTypeId: data.room_type_id,
            title: data.room_type_title,
        };
        this.accommodations = Object.values(data.accommodations || []).map(({ description, group_name, hasDescription, images, name, room_id, room_position, }) => ({
            description,
            group_name: group_name || '',
            hasDescription,
            images: images.map((image) => new Image(image)),
            name,
            position: room_position,
            roomId: room_id.toString().split('-')[0],
            unitId: room_id.toString(),
        }));
        this.smartPolicyRootId = data.smart_policy_root_id || '';
        this.detailedRates = (data.detailed_rates || []).map((dr) => {
            var _a;
            return ({
                adults: dr.adults,
                baseRate: dr.base_rate,
                date: dr.date,
                kids: dr.kids,
                packageRate: (_a = dr.package_rate) !== null && _a !== void 0 ? _a : dr.rate,
                rate: dr.rate,
            });
        });
        this.nights = this.detailedRates.length;
        this.maxGuests = parseInt(data.max_guests);
        this.maxAdults = data.max_adults ? parseInt(data.max_adults) : null;
        this.maxKids = data.max_children ? parseInt(data.max_children) : null;
        this.maxRooms = data.max_rooms;
        this.numBeds = parseInt(data.num_beds || '1');
        this.numAvailable = data.num_available_now;
        this.numRemaining = data.remaining;
        this.images = data.photos_gallery.map((src, index) => ({
            alt: data.photos_gallery_alt[index],
            src: src,
            thumb: src,
        }));
        if (!(options === null || options === void 0 ? void 0 : options.isUsingNewAmenitiesSystem)) {
            this.amenities =
                ((_e = data.features) === null || _e === void 0 ? void 0 : _e.map((name) => ({
                    name,
                }))) || [];
        }
        // For accommodations that can be individual selectable
        this.unit_ids = (_f = data.unit_ids) !== null && _f !== void 0 ? _f : [];
    }
}
